import 'client-only';

export function getScrollbarWidth(): number {
  if (typeof document === 'undefined') {
    return 0;
  }
  const outer = document?.createElement('div');
  outer.style.visibility = 'hidden';
  outer.style.overflow = 'scroll'; // forcing scrollbar to appear
  document?.body.appendChild(outer);

  const inner = document?.createElement('div');
  outer.appendChild(inner);

  const scrollbarWidth = outer.offsetWidth - inner.offsetWidth;

  outer.parentNode && outer.parentNode.removeChild(outer);

  return scrollbarWidth;
}
